import React from "react";
import classnames from "classnames";
import { Nav, NavItem, NavLink } from "reactstrap";
import { VIEW_OFFER_TABS } from "./constants/initialValues";

const ViewOfferSubTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="rv-nav d-flex">
      <Nav role="tablist">
        <NavItem>
          <NavLink
            to="#"
            className={activeTab === VIEW_OFFER_TABS.ONE_TIME ? "active" : ""}
            onClick={() => {
              setActiveTab(VIEW_OFFER_TABS.ONE_TIME);
            }}
            type="button"
          >
            {/* <OneTimeIcon /> */}
            <span className="ms-2">One Time</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            to="#"
            className={activeTab === VIEW_OFFER_TABS.RECURRING ? "active" : ""}
            onClick={() => {
              setActiveTab(VIEW_OFFER_TABS.RECURRING);
            }}
            type="button"
          >
            {/* <RecurringIcon /> */}
            <span className="ms-2">Recurring</span>
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
};

export default ViewOfferSubTabs;
